import React, { FC, useContext } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { DistanceFrom } from 'components/DistanceFrom';
import { HotelCardContext } from 'components/HotelCardContext';
import { getSearchType } from 'modules/sapiSearch/selectors';
import { SearchType } from 'modules/sapiSearch/utils';
import { getIsUserOrUrlLocationSearch } from 'modules/search/selectors';
import { toggle } from 'opticks';
import { Location } from '@daedalus/shared/src/search/Location';
const DistanceToWrapper = /*#__PURE__*/styled('div')({
  name: "DistanceToWrapper",
  class: "d17yfnir",
  propsAsIs: false
});
interface Props {
  distance: number;
  placeName: string;
  isCompactHotelCard?: boolean;
}
export const LocationDetails: FC<Props> = ({
  distance,
  placeName,
  isCompactHotelCard
}) => {
  const {
    hotelId
  } = useContext(HotelCardContext);
  const searchType = useSelector(getSearchType);
  const isUserOrUrlLocationSearch = useSelector(getIsUserOrUrlLocationSearch);
  const forceHideDistance = toggle('70766997-desktop-hotel-card-secondary-offers', false, true);
  const isShowingDistanceTo = searchType !== SearchType.Area || isUserOrUrlLocationSearch;
  return <div>
      <div data-id="Location">
        <Location place={placeName} hotelId={hotelId} />
      </div>
      {!forceHideDistance && isShowingDistanceTo && !isCompactHotelCard && <DistanceToWrapper data-id="DistanceTo">
          <DistanceFrom distance={distance} />
        </DistanceToWrapper>}
    </div>;
};

require("./LocationDetails.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./LocationDetails.tsx");